import ProfileAlbumsPage from './ProfileAlbumsPage'

export default ProfileAlbumsPage
